import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e223c29"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal is-active" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-background" }, null, -1))
const _hoisted_3 = { class: "modal-card" }
const _hoisted_4 = { class: "modal-card-head" }
const _hoisted_5 = { class: "modal-card-title is-title-shrink" }
const _hoisted_6 = { class: "modal-card-body" }
const _hoisted_7 = {
  key: 0,
  class: "custom-amount-input"
}
const _hoisted_8 = { class: "amount custom-amount-input" }
const _hoisted_9 = { class: "frame3-sub-title mt-3" }
const _hoisted_10 = {
  key: 0,
  class: "ml-2 min-credit-amount"
}
const _hoisted_11 = {
  key: 1,
  class: "ml-2 min-credit-amount"
}
const _hoisted_12 = { class: "is-flex" }
const _hoisted_13 = ["placeholder"]
const _hoisted_14 = { class: "amount-currency-symbol pl-2" }
const _hoisted_15 = {
  key: 0,
  class: "notification is-danger is-light"
}
const _hoisted_16 = { class: "modal-card-foot custom-modal-card-foot is-justify-content-flex-end" }
const _hoisted_17 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("header", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$gettext("Top up my account")), 1),
        _createElementVNode("button", {
          class: "delete",
          "aria-label": "close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.resetCredit(), _ctx.$modal.close()))
        })
      ]),
      _createElementVNode("section", _hoisted_6, [
        (_ctx.creditOrderUrl.length === 0 && _ctx.$modal.step.value == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _withDirectives(_createElementVNode("div", _hoisted_8, [
                _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.$gettext("Top up amount")), 1),
                (_ctx.selectedCreditAccount?.minCreditAmount)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$gettext("Minimum credit amount: ")) + " " + _toDisplayString(_ctx.selectedCreditAccount?.minCreditAmount) + " " + _toDisplayString(_ctx.selectedCreditAccount?.curr || ""), 1))
                  : _createCommentVNode("", true),
                (_ctx.selectedCreditAccount?.maxCreditAmount)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.$gettext("Maximum credit amount: ")) + " " + _toDisplayString(_ctx.selectedCreditAccount?.maxCreditAmount) + " " + _toDisplayString(_ctx.selectedCreditAccount?.curr || ""), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_12, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.amount) = $event)),
                    ref: "amountcredit",
                    type: "number",
                    min: "0",
                    class: _normalizeClass(["input is-custom", { 'is-danger': _ctx.amountError }]),
                    placeholder: _ctx.$gettext('e.g. 50')
                  }, null, 10, _hoisted_13), [
                    [
                      _vModelText,
                      _ctx.amount,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _createElementVNode("span", _hoisted_14, _toDisplayString(this.selectedCreditAccount?.curr), 1)
                ]),
                _createElementVNode("div", null, [
                  (_ctx.amountError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.amountError), 1))
                    : _createCommentVNode("", true)
                ])
              ], 512), [
                [_vShow, 
              _ctx.selectedCreditAccount || _ctx.creditableMoneyAccounts.length === 1
            ]
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("footer", _hoisted_16, [
        (
            _ctx.creditOrderUrl.length === 0 &&
            (_ctx.selectedCreditAccount || _ctx.creditableMoneyAccounts.length === 1)
          )
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "button custom-button-modal button-modal has-text-weight-medium action",
              id: "top-up-button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.newLinkTab())),
              disabled: _ctx.amountError !== false
            }, _toDisplayString(_ctx.$gettext("Next")), 9, _hoisted_17))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}